import React from "react";
import { motion } from "framer-motion";
import { Button } from "../ui/button";
import { Star, ShieldCheck, Zap } from "lucide-react";
import { useBooking } from "./BookingProvider";

const HERO_IMG =
  "https://images.unsplash.com/photo-1572452571879-3d67d5b2a39f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";

export const Hero = () => {
  const { openBooking } = useBooking();

  return (
    <section id="home" className="relative min-h-[100svh] flex items-center overflow-hidden grain">
      <div className="absolute inset-0 z-0">
        <img src={HERO_IMG} alt="Rider on premium motorcycle" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/40" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/40 to-transparent" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl w-full px-5 sm:px-8 pt-28">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="max-w-3xl"
        >
          <div className="inline-flex items-center gap-2 rounded-full border border-primary/40 bg-primary/10 px-4 py-1.5 mb-6">
            <Star className="w-4 h-4 text-primary fill-primary" />
            <span className="text-xs sm:text-sm font-medium text-primary">Rated 4.9/5 by 12,000+ riders</span>
          </div>

          <h1 className="text-4xl sm:text-6xl lg:text-7xl font-display font-extrabold tracking-tight leading-[1.05]">
            Ride Your Freedom <br />
            with <span className="gold-text">Flyzone</span>
          </h1>

          <p className="mt-6 text-base sm:text-lg text-white/75 max-w-xl leading-relaxed">
            Affordable Bike &amp; Scooter Rentals for Daily Commute, Weekend Trips &amp; Travel. Best Bike &amp; Scooter Rental in Pune.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <Button
              data-testid="hero-book-now"
              onClick={() => openBooking(null)}
              className="rounded-full bg-primary text-black hover:bg-primary/90 font-semibold text-base h-13 px-8 py-6 gold-glow"
            >
              Book Now
            </Button>
            <Button
              asChild
              variant="outline"
              data-testid="hero-view-fleet"
              className="rounded-full border-white/30 bg-white/5 text-white hover:bg-white hover:text-black font-semibold text-base h-13 px-8 py-6"
            >
              <a href="#fleet">View Fleet</a>
            </Button>
          </div>

          <div className="mt-14 flex flex-wrap gap-x-8 gap-y-4">
            {[
              { icon: Zap, label: "Instant Booking" },
              { icon: ShieldCheck, label: "Free Helmet & Insurance" },
              { icon: Star, label: "24/7 Support" },
            ].map((f) => (
              <div key={f.label} className="flex items-center gap-2 text-white/70">
                <f.icon className="w-5 h-5 text-primary" />
                <span className="text-sm font-medium">{f.label}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
